import { render, staticRenderFns } from "./tab3.vue?vue&type=template&id=a2e3a68c&scoped=true&"
var script = {}
import style0 from "./tab3.vue?vue&type=style&index=0&id=a2e3a68c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e3a68c",
  null
  
)

export default component.exports